import {Injectable} from '@angular/core';
import {AuthData} from '../../graphql/generated';
import {GraphqlService} from './graphql.service';
import {loginQuery} from '../../graphql/queries/auth';
import {InvalidCredentialsError} from '../exceptions/exceptions';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private graphqlService: GraphqlService,
    private jwtHelper: JwtHelperService,
    private router: Router,
  ) {
  }

  async authenticateUser(email: string, password: string): Promise<AuthData> {
    try {
      const response = await this.graphqlService.runQuery(loginQuery, {
        email,
        password,
      });

      return response.login;
    } catch (error) {
      throw new InvalidCredentialsError('Invalid credentials.');
    }
  }

  isUserAuthenticated(): boolean {
    const accessToken = localStorage.getItem('accessToken');
    return !this.jwtHelper.isTokenExpired(accessToken);
  }

  saveAuthData(authData: AuthData): void {
    localStorage.setItem('accessToken', authData.access_token);
    localStorage.setItem('refreshToken', authData.refresh_token);
    localStorage.setItem('userId', authData.id);
  }

  refreshAccessToken() {
    // TODO: Refresh access token.
  }

  checkUser() {
    if (this.isUserAuthenticated()) {
      this.router.navigate(['/main/branches']).then();
    }
  }
}
